export default __webpack_public_path__ + "static/media/img_gardone_paye.962f2895.png";